import Fuse from 'fuse.js';

import { normalizeForSearch } from './normalize-for-search';

type Keys<Item extends object> =
  | Array<keyof Item>
  | Array<{ key: keyof Item; weight: number }>;

export type AutoCompleteSuggestionsOptions = {
  threshold?: number;
};

export const getAutoCompleteSuggestions = <Item extends object>(
  input: string | undefined,
  values: Item[],
  keys: Keys<Item>,
  { threshold }: AutoCompleteSuggestionsOptions = { threshold: 0.4 },
) => {
  if (!input) {
    return values;
  }

  const fuse = new Fuse(values, {
    keys: keys.map((key) => {
      if (typeof key === 'object' && 'key' in key && 'weight' in key) {
        return { name: key.key as string, weight: key.weight };
      }
      return key as string;
    }),
    threshold,
    getFn: (obj, path) => {
      const value = Fuse.config.getFn(obj, path);
      // a key this item does not carry comes back undefined, not an empty array
      if (!value) {
        return '';
      }
      if (typeof value === 'string') {
        return normalizeForSearch(value);
      }
      return value.map((entry) => normalizeForSearch(entry));
    },
  });

  const result = fuse.search(normalizeForSearch(input));
  return result.map(({ item }) => item);
};
